import { atom } from 'recoil';

export const startAnimationState = atom({
  key: 'startAnimation',
  default: false,
});